import { EDealType } from './filters';
import { ELoadingStatus } from './loadingStatus';

export type TProduct = {
  id: number;
  offerType: 'offer';
  position: number;
};

export type TOfferAnalyticsData = {
  type: 'offer';
  OfferID: string;
  tag: string;
  offerId: number;
  products: [TProduct];
};

export enum EOfferType {
  Commercial = 'commercial',
  Flat = 'flat',
  Newobject = 'newobject',
  Suburban = 'suburban',
}

export enum EEntityType {
  Newbuilding = 'newbuilding',
  OfferCommercial = 'offerCommercial',
  OfferResidental = 'offerResidental',
  OfferSuburban = 'offerSuburban',
}

export interface IUnderground {
  lineColor: string;
  name: string;
  time: number;
  transportType: string;
}

export type TRecommendation = {
  analyticsData?: object;
  dealType: EDealType;
  discount?: IDiscount;
  offerId: number;
  entityType: EEntityType;
  imageUrl: string;
  info?: string;
  isFavorite: boolean;
  offerType: EOfferType;
  description?: string;
  title?: string;
  underground?: IUnderground;
  href: string;
};

export interface IOfferPhoto {
  id: number;
  url: string;
}

export interface IDiscount {
  newPrice: string;
  oldPrice: string;
  percent: string;
}

export enum EPaginationStatus {
  Idle = 'idle',
  Loading = 'loading',
  Error = 'error',
}

export interface IRecommendation {
  data: TRecommendation[];
  status: ELoadingStatus;
  page: number;
  hasMore: boolean;
  paginationStatus: EPaginationStatus;
}
